<template>
  <div>

    <v-text-field label="انتخاب کاربران" dense
                  outlined readonly append-icon="mdi-crosshairs" class="cursor-pointer" @click="dialog = true"
                  ref="input" :error-messages="errors"/>

    <v-dialog v-model="dialog" scrollable max-width="800px">
      <v-card elevation="2" outlined :loading="loading">
        <v-card-title>انتخاب کاربران</v-card-title>
        <v-divider></v-divider>

        <div class="row">

          <div class="col-md-12 p-5">
            <data-table
                :data="userInfo"
                :columns="columns"
                :translate="translate"
                :per-page="[10, 25, 50, 100]"
                @on-table-props-changed="reloadTable">
              <div slot="filters" slot-scope="{ tableFilters, perPage }">
                <div class="row mb-2">
                  <div class="col-md-4">
                    <select class="form-control pr-3" v-model="tableFilters.length">
                      <option :key="page" v-for="page in perPage">{{ page }}</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                  </div>

                  <div class="col-md-4 ">
                    <v-text-field
                        v-model="tableFilters.search"
                        outlined
                        dense
                        label="جست و جو"
                        class="pl-3"
                    >

                    </v-text-field>
                  </div>
                </div>
              </div>

            </data-table>
          </div>
        </div>


      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import pagination from "@/view/pages/pickers/pagination";
import routePagination from "@/view/content/route-pagination";
import CheckboxFild from "@/view/pages/admin/users/CheckboxFild";
import userManageButton from "@/view/pages/admin/users/userManageButton";
import loginRollback from "@/Utilities/LoginRollback";
import jwtService from "@/core/services/jwt.service";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
  components: {pagination, routePagination},
  name: "userPicker",

  props: ['value', 'errors'],

  model: {
    prop: 'value',
    event: 'manufacturersPicker'
  },

  data() {
    return {
      selectedRows : [],
      dialog: false,
      userWallet: [],
      dialogInfo: null,
      loading:false,
      translate: {
        nextButton: 'بعدی',
        previousButton: 'قبلی',
        rowsPerPageText: 'تعداد در صفحه',
        noDataText: 'داده ای برای نمایش وجود ندارد',
        placeholderSearch: 'جستجو',
      },
      url: 'admin/users',
      userInfo:{},
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
      columns: [
        {
          label: `<input type="checkbox" id="select_all" onclick="window.Vue.$emit('selectAllListCheckBox', this)"/>`,
          component: CheckboxFild,
          event: 'change',
          handler: this.change,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          colStyle: 'width: 100px;'
        },
        {
          label: 'نام',
          name: 'name',
          orderable: true,
        },
        {
          label: 'نام کاربری',
          name: 'username',
          orderable: true,
        },
        {
          label: 'تلفن',
          name: 'phone',
          orderable: true,
        },
        {
          label: 'نوع کاربر',
          name: 'type',
          orderable: true,
          transform: (value, data) => {
            return value.data.type == 'regular' ? 'شخص حقیقی' : 'شخص حقوقی';
          }
        },

      ],
    }
  },


  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
    this.getUserInfo(this.url)

    window.Vue.$on('selectAllListCheckBox', (e)=>{
      this.selectAll(e.checked);
    })
  },

  methods: {
    selectAll(c) {
      window.Vue.$emit("selectedAllCheckbox", c);
    },
    change(data, checked) {
      if (checked){
        this.selectedRows.push(data.id);
      }else{
        let index = this.selectedRows.indexOf(data.id)
        this.selectedRows = [
          ...this.selectedRows.slice(0, index),
          ...this.selectedRows.slice(index + 1 , this.selectedRows.length)
        ]

      }
      window.document.querySelector("#select_all").checked = this.selectedRows.length == this.userInfo.data.length
    },


    getUserInfo(url = this.url, params = this.tableProps) {
      this.requestApiGet(url, params).then(response => {
        this.userInfo = response.data;
      })
    },

    reloadTable(params) {
      this.getUserInfo(this.url, params)
    },

    actions(data, type) {
      this[type](data)
    },
    edit(data) {
      this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
    },
    information(data) {
      this.$router.push({name: 'admin.users.information', params: {id: data.id}})
    },
  },
  watch:{
    selectedRows(){
      this.$emit('manufacturersPicker', this.selectedRows)
    }
  }
}

$('#select_all').click(function () {
  $('.checkBox').prop('checked', $(this).prop("checked"));
})
</script>

<style scoped>

</style>
